  <template>
	<div>
     <el-form ref="form" :rules="rules" :model="curInput.interface" label-width="100px">
      <el-form-item label="接口方式" prop="method">
        <el-radio class="radio" v-model="curInput.interface.method" label="GET">GET</el-radio>
        <el-radio class="radio" v-model="curInput.interface.method" label="POST">POST</el-radio>
      </el-form-item>
      <el-form-item label="接口地址" prop="api_url">
        <el-input class="h-40 w-300" placeholder="请输入" v-model.trim="curInput.interface.api_url"></el-input>
      </el-form-item>

      <el-form-item label="关键传入参数名">
        <el-input class="h-40 w-300" placeholder="请输入" v-model="curInput.interface.key"></el-input>
        <div class="form-tips">也就是用户输入的那个输入框的参数名是什么，例如:vin</div>
      </el-form-item>

      <el-form-item label="接口传入参数" >
        <el-input class="h-40 w-300" placeholder="请输入" v-model="curInput.interface.data"></el-input>
        <div class="form-tips">用':'写键值对，多参数用',' 隔开，例如:key:123456,appid:123</div>
      </el-form-item>

      <el-form-item label="返回状态参数" >
        <el-input class="h-40 w-300" placeholder="请输入" v-model="curInput.interface.status"></el-input>
        <div class="form-tips">用'/'作为多维数组分隔符,例如:ret/status</div>
      </el-form-item>
      
      <el-form-item label="提示语配置">
        <el-table
          :data="curInput.interface.error_msg"
          style="width:480px">
          <el-table-column
            prop="date"
            label="状态码">
            <template scope="scope">
              <el-input placeholder="返回的状态码" v-model="scope.row.error_code"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="提示语">
            <template scope="scope">
              <el-input placeholder="返回的提示语" v-model="scope.row.msg"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="60">
            <template scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, curInput.interface.error_msg)"
                type="text"
                size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="m-t-5" size="small" @click="addErrorStatus">增加一个</el-button>
      </el-form-item>
      
      <el-form-item label="正常参数值">
        <el-input class="h-40 w-300" placeholder="请输入" v-model="curInput.interface.success_status"></el-input>
      </el-form-item>

      <el-form-item label="返回参数内容">
        <el-input class="h-40 w-300" placeholder="请输入" v-model="curInput.interface.content"></el-input>
        <div class="form-tips">用'/'作为多维数组分隔符,例如:ret/info</div>
      </el-form-item>
    
      <el-form-item label="返回参数内容对应控件" >
        <el-table
          :data="curInput.interface.set_field"
          style="width:480px">
          <el-table-column
            prop="date"
            label="返回的参数名">
            <template scope="scope">
              <el-input placeholder="返回的参数名" v-model="scope.row.param"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="对应本表单的字段控件">
            <template scope="scope">
              <el-select v-model="scope.row.fieldname" placeholder="请选择" @visible-change="getFieeldName(scope.row)">
                <el-option
                  v-for="item in fieldNames"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="60">
            <template scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, curInput.interface.set_field)"
                type="text"
                size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="m-t-5" size="small" @click="addField">增加一个</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import http from '../../../assets/js/http'
import modelConfig from '../../../config/modelConfig'
export default {
  props: ['curInput', 'inputList'],
  data() {
    return {
      fieldNames: [],
      newInputLists: [],
      rules: {
        api_url: [
          { required: true, message: '请输入接口地址' }
        ],
        method: [
          { required: true, message: '请输入接口方式' }
        ]
      }
    }
  },
  methods: {
    addField() {
      this.curInput.interface.set_field.push({
        param: '',
        fieldname: ''
      })
    },
    addErrorStatus() {
      this.curInput.interface.error_msg.push({
        error_code: 0,
        msg: ''
      })
    },
    deleteRow(index, rows) {
      rows.splice(index, 1)
    },
    getFieeldName(item) {
      this.fieldNames = []
      _(this.inputList).forEach((input) => {
        if (input.default.type != this.TYPE_OBTAIN_CONTENT) {
          if (input.default.is_deleted != 1) {
            this.fieldNames.push({
              label: input.default.name,
              value: input.default.name
            })
          }
        }
      })
    }
  },
  mixins: [http, modelConfig]
}
</script>


// WEBPACK FOOTER //
// obtainConfig.vue?6becd7e6